export function zipCodeValidator(countryNameInput, zipValueInput) {
  let countryName = (countryNameInput || "").toUpperCase().trim();
  let zipValue = (zipValueInput || "").replaceAll(/[^\d]/g, "");
  let errorArray = [];
  if (countryName == "CHINA" || countryName == "CN") {
    if (!zipValue || zipValue.length === 0) {
      errorArray.push((fieldName) => {
        return `Postal Code: ${fieldName} is missing a Postal Code for Country ${countryName}`;
      });
    } else if (!/^[0-9]{6}$/.test(zipValue)) {
      errorArray.push((fieldName) => {
        return `Postal Code: ${fieldName} must be 6 digits for Country ${countryName} - NNNNNN`;
      });
    }
  }
  return errorArray;
}
